const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const equipmentCopy = document.querySelector('.equipment-copy');
if (equipmentCopy) {
  equipmentCopy.insertAdjacentHTML('afterbegin', '<div class="equipment-reassurance"><h3>Vous êtes déjà équipée ?</h3><p>Aucun achat supplémentaire n’est nécessaire pour participer à la formation.</p><h3>Vous souhaitez également lancer votre espace Head Spa ?</h3><p>Skiin peut vous accompagner de la formation jusqu’à l’équipement professionnel.</p></div>');
}

const applyHeading = document.querySelector('.apply-intro h2');
const applyLead = document.querySelector('.apply-intro > p:not(.eyebrow)');
if (applyHeading) applyHeading.innerHTML = 'Prête à intégrer le Head Spa<br><em>à votre activité ?</em>';
if (applyLead) applyLead.textContent = 'Envoyez votre demande d’inscription. Notre équipe vous recontactera pour confirmer la session choisie et les prochaines étapes.';

// Les vidéos d'ambiance sont muettes et relancées lorsque le navigateur autorise
// l'autoplay. Le rejet éventuel de play() est volontairement silencieux.
const ambientVideos = [...document.querySelectorAll('video')];
const playAmbientVideos = () => {
  ambientVideos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.controls = false;
    const playback = video.play();
    if (playback) playback.catch(() => {});
  });
};

ambientVideos.forEach((video) => {
  video.addEventListener('canplay', playAmbientVideos, { once: true });
});
window.addEventListener('pageshow', playAmbientVideos);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) playAmbientVideos();
});
playAmbientVideos();

if (!reducedMotion && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
} else {
  document.querySelectorAll('.reveal').forEach((element) => element.classList.add('visible'));
}

document.querySelectorAll('.accordion details').forEach((detail) => {
  detail.addEventListener('toggle', () => {
    if (!detail.open) return;
    document.querySelectorAll('.accordion details[open]').forEach((other) => {
      if (other !== detail) other.removeAttribute('open');
    });
  });
});

const form = document.querySelector('#apply-form');

const customSelects = [];
form.querySelectorAll('select').forEach((select) => {
  const label = form.querySelector(`label[for="${select.id}"]`);
  const component = document.createElement('div');
  const trigger = document.createElement('button');
  const value = document.createElement('span');
  const chevron = document.createElement('span');
  const panel = document.createElement('div');
  const choices = [...select.options].filter((option) => option.value);

  select.classList.add('custom-select-native');
  component.className = 'custom-select';
  trigger.className = 'custom-select-trigger';
  trigger.type = 'button';
  trigger.setAttribute('aria-haspopup', 'listbox');
  trigger.setAttribute('aria-expanded', 'false');
  trigger.setAttribute('aria-label', label.textContent.replace('*', '').trim());
  panel.className = 'custom-select-panel';
  panel.id = `${select.id}-options`;
  panel.setAttribute('role', 'listbox');
  panel.setAttribute('aria-label', label.textContent.replace('*', '').trim());
  panel.hidden = true;
  trigger.setAttribute('aria-controls', panel.id);
  value.className = 'custom-select-value';
  chevron.className = 'custom-select-chevron';
  chevron.setAttribute('aria-hidden', 'true');
  chevron.textContent = '⌄';
  trigger.append(value, chevron);

  const close = (restoreFocus = false) => {
    component.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    if (restoreFocus) trigger.focus();
  };

  const sync = () => {
    const selected = select.options[select.selectedIndex];
    value.textContent = selected.textContent;
    trigger.classList.toggle('is-placeholder', !select.value);
    trigger.classList.remove('is-invalid');
    panel.querySelectorAll('[role="option"]').forEach((option) => {
      const active = option.dataset.value === select.value;
      option.setAttribute('aria-selected', String(active));
      option.classList.toggle('is-selected', active);
    });
  };

  const choose = (option) => {
    select.value = option.dataset.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    close(true);
  };

  choices.forEach((option, index) => {
    const choice = document.createElement('button');
    choice.className = 'custom-select-option';
    choice.type = 'button';
    choice.setAttribute('role', 'option');
    choice.setAttribute('aria-selected', 'false');
    choice.dataset.value = option.value;
    choice.innerHTML = `<span>${option.textContent}</span><i aria-hidden="true">✓</i>`;
    choice.addEventListener('click', () => choose(choice));
    choice.addEventListener('keydown', (event) => {
      const options = [...panel.querySelectorAll('[role="option"]')];
      const current = options.indexOf(choice);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        options[(current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length].focus();
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        options[event.key === 'Home' ? 0 : options.length - 1].focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(choice);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      }
    });
    panel.append(choice);
  });

  trigger.addEventListener('click', () => {
    const willOpen = panel.hidden;
    customSelects.forEach((item) => item.close());
    if (willOpen) {
      component.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  });
  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      event.preventDefault();
      close(true);
      return;
    }
    if (!['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (panel.hidden) trigger.click();
    const options = [...panel.querySelectorAll('[role="option"]')];
    const selectedIndex = Math.max(0, options.findIndex((option) => option.classList.contains('is-selected')));
    options[event.key === 'ArrowUp' ? options.length - 1 : selectedIndex].focus();
  });
  select.addEventListener('change', sync);
  select.addEventListener('invalid', (event) => {
    event.preventDefault();
    trigger.classList.add('is-invalid');
    trigger.focus();
  });

  component.append(trigger, panel);
  component.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (!component.contains(document.activeElement)) close();
    });
  });
  select.insertAdjacentElement('afterend', component);
  customSelects.push({ component, trigger, panel, close, sync });
  sync();
});

document.addEventListener('click', (event) => {
  customSelects.forEach((item) => {
    if (!item.component.contains(event.target)) item.close();
  });
});

document.querySelectorAll('.session-choice').forEach((link) => {
  link.addEventListener('click', () => {
    form.elements.session.value = link.dataset.session;
    form.elements.session.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

const datesToggle = document.querySelector('.dates-toggle');
const moreSessions = document.querySelector('#more-sessions');
if (datesToggle && moreSessions) {
  datesToggle.addEventListener('click', () => {
    const expanded = datesToggle.getAttribute('aria-expanded') === 'true';
    datesToggle.setAttribute('aria-expanded', String(!expanded));
    moreSessions.hidden = expanded;
    datesToggle.firstChild.textContent = expanded ? 'Voir toutes les dates ' : 'Réduire les dates ';
    datesToggle.querySelector('span').textContent = expanded ? '+' : '−';
  });
}

const mobileSticky = document.querySelector('.mobile-sticky');
const mobileQuery = window.matchMedia('(max-width: 850px)');
const redundantMobileCtas = [
  document.querySelector('.hero .button[href="#inscription"]'),
  document.querySelector('.apply'),
  document.querySelector('footer')
].filter(Boolean);
const visibleRedundantCtas = new Set();
const syncMobileSticky = () => {
  mobileSticky.classList.toggle('is-suppressed', mobileQuery.matches && visibleRedundantCtas.size > 0);
};

redundantMobileCtas.forEach((button) => {
  const rect = button.getBoundingClientRect();
  if (rect.top < window.innerHeight && rect.bottom > 0) visibleRedundantCtas.add(button);
});
syncMobileSticky();

if ('IntersectionObserver' in window) {
  const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visibleRedundantCtas.add(entry.target);
      else visibleRedundantCtas.delete(entry.target);
    });
    syncMobileSticky();
  }, { threshold: 0.15 });
  redundantMobileCtas.forEach((button) => stickyObserver.observe(button));
}
mobileQuery.addEventListener('change', syncMobileSticky);

